const urlName = '/bi/v1/statistics'

export default API => ({
    getAllLearnedData() { 
        return API({ 
            url: `${urlName}/getAllLearnedData`, 
            method:  'get',
        });
    },
    getAllTrainCampData() {
        return API({ 
            url: `${urlName}/getAllTrainCampData`,
            method:  'get',
        });
    },
})